














import {Component, Prop, Vue} from "vue-property-decorator";
import {Entry} from "@/types/entry";

@Component
export default class EntryComponent extends Vue {
    @Prop() private entry!: Entry;

    get cssClass() {
        return "entry entry-" + this.entry.readableType;
    }
}
